import { displayFlex, media } from '@onhandtech/onhand-toolkit'
import styled from 'styled-components'

export const AuthLayout = styled.main`
  ${displayFlex({ flexDirection: 'column' })}
  width: 100%;
  height: 100vh;

  @media ${media.tabletLandscape} {
    ${displayFlex()}
  }
`

export const LeftPanel = styled.div`
  ${displayFlex({ flexDirection: 'column' })}

  > div:first-child {
    color: ${({ theme }) => theme.colours.teal};
    margin-top: 1rem;
  }

  > h3 {
    display: none;
  }

  @media ${media.tabletLandscape} {
    ${displayFlex({ flexDirection: 'column' })}
    float: left;
    width: 50%;
    height: 100vh;
    background: ${({ theme }) => theme.colours.earth};
    padding-bottom: 10rem;

    > div:first-child {
      transform: scale(1.9);
      margin-bottom: 2rem;
      color: ${({ theme }) => theme.colours.sunshine};
    }

    > h3 {
      display: block;
    }
  }
`

export const RightPanel = styled.div`
  width: 100%;
  height: 100vh;
  padding: 1rem;

  @media ${media.tabletLandscape} {
    ${displayFlex()}
    float: right;
    width: 50%;
    padding: 8rem 2rem 8rem 2rem;
  }

  @media ${media.laptop} {
    padding: 8rem 4rem 12rem 4rem;
  }

  @media ${media.desktop} {
    padding: 8rem 6rem 20rem 6rem;
  }
`

export const Logo = styled.img`
  height: 10rem;
`
